import React, { useRef } from 'react';
import { TextField } from '@mui/material';
import ModalWrapper from '../ModalWrapper';
import { FormSchemas, FormWrapper } from '../FormComponent';
import CommonFooter from '../FormComponent/CommonFooter';

const EditModuleModal = ({ isOpen, onClose, onConfirm, nodeName, context, title = "Edit Module" }) => {

  const formRef = useRef(null);

  const handleFormSubmit = async () => {
    if (formRef.current) await formRef.current.submit();
  };

  const handleConfirm = (data) => {
    const updatedName = data.moduleName.trim();
    const context = data.moduleContext;
    // if (updatedName && updatedName !== nodeName) {
      onConfirm(updatedName, context);
    // }
    onClose();
  };

  const fields = [
    {
      name: 'moduleName',
      type: 'text',
      label: 'Name',
      placeholder: 'Enter your full module name',
      required: true,
    },
    {
      name: 'moduleContext',
      type: 'text',
      label: 'Context',
      placeholder: 'Enter your context',
      multiline: true,
      rows: 4
    },
  ]

  const buttons = [
    {
      label: 'Cancel',
      variant: 'outline',
      className: 'primary',
      onClick: onClose,
    },
    {
      label: 'Save',
      variant: 'primary',
      className: 'white bg-blue600',
      onClick: handleFormSubmit,
    },
  ];


  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="small"
      footer={
        <CommonFooter
          buttons={buttons}
          align="right"
        />
      }
      children={
        <FormWrapper
          ref={formRef}
          schema={FormSchemas.moduleForm}
          fields={fields}
          onSubmit={handleConfirm}
          defaultValues={{
            moduleName: nodeName,
            moduleContext: context
          }}
        />
      }
    />
  );
};

export default EditModuleModal;